@if (product && !variant) {
  <div class="product">
    <div class="two-colmn-grid">
      <!--         <div class="column1">
              <h2 class="no-overflow">{{ product.name }}</h2>
          </div> -->
      <div class="column2 headline right">
        <!--             <squared-button class="edit-btn" [label]="'Produkt veröffentlichen'" (click)="licenseProduct()"
                  *ngIf="isPlattformAdmin"></squared-button>
  
              <squared-button class="edit-btn" [label]="'Produkt bearbeiten'" (click)="editProduct()"
                  *ngIf="isPlattformAdmin"></squared-button>
              <squared-button class="del-btn" [label]="'Produkt löschen'" [color]="'btn_red'" (click)="deleteProduct()"
                  *ngIf="isPlattformAdmin"></squared-button> -->
        <!-- <rounded-button
                  [label]="'SSO'"
                  (click)="registerSsoClient()"
                  *ngIf="isPlattformAdmin"
              ></rounded-button>
              <rounded-button
                  [label]="'Störungsmanagement'"
                  (click)="showMalfunctionManagement()"
                  *ngIf="isPlattformAdmin && hasActiveProductVersion"
              ></rounded-button> -->
      </div>
    </div>
    <div class="product-info-conatiner">
      <div>
        <p class="description" [innerHTML]="product.description"></p>
      </div>
      <div *ngIf="product.features.length > 0">
        <h3>Stärken des Produktes</h3>
        <div class="features-list">
          <div *ngFor="let productFeature of product.features" class="feature-item">
            <span> {{ productFeature }} </span>
          </div>
        </div>
      </div>
      <!--             <div class="version-count">
                  <div>
                      <b>
                          <p>Varianten</p>
                      </b>
                      <b>
                          <h2>{{ product.productVariants.length }}</h2>
                      </b>
                  </div>
              </div> -->
      <!--         <div class="image-wrapper">
              <div class="image-preview">
                  <app-secure-image
                      [src]="this.productPictureUrl"
                      [fileId]="product.fileId"
                  ></app-secure-image>
              </div>
          </div> -->
    </div>
    <div *ngIf="showPictures && product && product.galleryPictureIds" class="info-box-gallery">
      <b>
        <p>Galerie</p>
      </b>
    </div>
  </div>
}

@if (certification) {
  <div class="ptg">
    <div class="two-colmn-grid wide">
      <div class="column1">
        <h2 class="no-overflow">{{ certification.name }}</h2>
      </div>
      <div class="column2 headline right">
        <button mat-stroked-button color="primary" *ngIf="isPlattformAdmin" class="cert-admin-action"
          (click)="editCertification()">Zertifizierung bearbeiten</button>
        <button mat-stroked-button color="warn" *ngIf="isPlattformAdmin" class="cert-admin-action"
          (click)="deleteCertification()">Zertifizierung löschen</button>
      </div>
    </div>
    <div class="version-info">
      <div>
        <p class="description" [innerHTML]="certificationDescription"></p>
        <div class="version-count">
          <div>
            <b>
              <p>Varianten</p>
            </b>
            <b>
              <!-- TODO: FIX missing Parameterns in case of undefined; flache Scope-Elemente -->
              <h2>
                {{ certification.certificationVariants.length }}
              </h2>
            </b>
          </div>
        </div>
      </div>
      <div class="image-wrapper">
        <div class="image-preview">
          <app-secure-image [src]="this.certificationPictureUrl" [fileId]="certification.fileId"></app-secure-image>
        </div>
      </div>
    </div>
    <div *ngIf="showPictures && certification && certification.galleryPictureIds" class="info-box-gallery">
      <b>
        <p>Galerie</p>
      </b>
    </div>
  </div>
}

@if (variant) {
  <div class="variant-card-container">
    <mat-card class="variant-card" (click)="onVariantCardClick(product, variant); toggle()">
      <div class="variant-summary">
        <div class="summary-left">
          <h2 class="variant-title">{{ variant?.name }}</h2>
          <div class="summary-meta">
            <span><b style=" margin: 0px 40px 0 0;">Versionen:</b> {{ variant?.variantVersions?.length || 0 }}</span>
            <span>
              <b style=" margin: 0px 30px 0 0;">Davon aktiv:</b>
              {{ (variant?.variantVersions | variantVersionActive)?.length || 0 }}
            </span>
          </div>
        </div>
        <div>
          <button mat-icon-button class="expand-icon" (click)="$event.stopPropagation(); onVariantCardClick(product, variant); toggle()"
            [attr.aria-expanded]="isExpanded" [ngClass]="{ rotated: isExpanded }" aria-label="Details anzeigen">
            <mat-icon>expand_more</mat-icon>
          </button>
          <button mat-icon-button (click)="$event.stopPropagation(); onVariantCardClick(product, variant)" [matMenuTriggerFor]="moreMenu"
            aria-label="More actions">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            <button mat-menu-item (click)="onVariantEdit(product.id, variant.id)">
              <span>Variante bearbeiten</span>
            </button>
            <button mat-menu-item (click)="deleteVariant(product.id, variant.id)">
              <span>Variante löschen</span>
            </button>
          </mat-menu>
        </div>
      </div>
  
      <!-- TOOD Expansion pannel funktioniert nicht richtig -->
      <div *ngIf="isExpanded" hideToggle class="variant-expansion">
        <div class="expanded-content">
          <p><b>Beschreibung</b></p>
          <p class="description" [innerHTML]="variantDescription"></p>
  
          <div class="versions-list" *ngIf="variant?.variantVersions?.length">
            <div class="versions-table" *ngIf="variant?.variantVersions?.length">
              <h3>Versionen</h3>
              <table mat-table [dataSource]="variant.variantVersions" class="mat-elevation-z0 full-width">
                <!-- Version Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef> Version </th>
                  <td mat-cell *matCellDef="let v"> {{ v?.name || '—' }} </td>
                </ng-container>
  
                <!-- Active/Inactive Toggle Column -->
                <ng-container matColumnDef="active">
                  <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let v">
                    <button mat-stroked-button matButton="elevated" class="status-toggle" color="primary"
                      [ngClass]="{ active: v?.status === Status.ACTIVE, inactive: v?.status !== Status.ACTIVE }"
                      (click)="$event.stopPropagation(); toggleVersionActive(v)"
                      [attr.aria-pressed]="v?.status === Status.ACTIVE"
                      [attr.aria-label]="v?.status === Status.ACTIVE ? 'Version deaktivieren' : 'Version aktivieren'">
                      {{ v?.status === Status.ACTIVE ? 'Aktiv' : 'Inaktiv' }}
                    </button>
                  </td>
                </ng-container>
  
                <!-- Previous Version Column -->
                <ng-container matColumnDef="previous">
                  <th mat-header-cell *matHeaderCellDef> Vorherige Version </th>
                  <td mat-cell *matCellDef="let v; let i = index">
                    {{ getPrevVersion(v) }}
                  </td>
                </ng-container>
  
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef> Aktionen </th>
                  <td mat-cell *matCellDef="let v">
                    <button mat-icon-button aria-label="Bearbeiten" color="primary"
                      (click)="$event.stopPropagation(); onDeleteVariantVersion(v.id, product.id, variant.id)">
                      <mat-icon>delete</mat-icon>
                    </button>
  
                    <button mat-icon-button aria-label="Bearbeiten" color="primary"
                      (click)="$event.stopPropagation(); onEditVariantVersion(v.id, product.id, variant.id)">
                      <mat-icon>edit</mat-icon>
                    </button>
  
                    <span
                      [matTooltip]="hasReachedVersionLimit(variant) 
                        ? `Es können maximal ${MAX_VERSIONS_PER_VARIANT} Versionen pro Variante angelegt werden.` 
                        : ''"
                      matTooltipPosition="above">
                      <button mat-icon-button aria-label="Bearbeiten" color="primary"
                        [disabled]="hasReachedVersionLimit(variant)"
                        (click)="$event.stopPropagation(); onAddVariantVersion(v.id, product.id, variant.id)">
                        <mat-icon>add</mat-icon>
                      </button>
                    </span>
                  </td>
                </ng-container>
  
                <!-- Header and Row Declarations -->
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
}

@if (certificationVariant) {
  <div class="versionsBackground">
    <div class="headline">
      <h2>{{ certificationVariant.name }}</h2>
    </div>
    <div class="version-info">
      <div class="twoRows">
        <p><b>Beschreibung</b></p>
        <p class="description" [innerHTML]="certificationVariantDescription"></p>
        <p><b>Kommentar</b></p>
        <p class="description">{{ certificationVariant.comment }}</p>
      </div>
      <div class="stats">
        <p><b>Versionen</b></p>
        <b>
          <h2>
            {{
            certificationVariant.certificationVariantVersions.length
            }}
          </h2>
        </b>
        <p><b>Davon aktiv</b></p>
        <b>
          <h2>
            {{
            (
            certificationVariant.certificationVariantVersions
            | variantVersionActive
            ).length
            }}
          </h2>
        </b>
      </div>
    </div>
  </div>
}
